import { Mark } from '@tiptap/core'

const VerticalAlign = Mark.create({
  name: 'verticalAlign',

  addOptions () {
    return {
      verticalAlign: null
    }
  },

  addAttributes () {
    return {
      verticalAlign: {
        default: null,
        parseHTML: element => {
          return element.style.verticalAlign || element.getAttribute('data-vertical-align') || null
        },
        renderHTML: attrs => {
          if (!attrs.verticalAlign) {
            return {}
          }

          return {
            style: `vertical-align:${attrs.verticalAlign};`
          }
        }
      }
    }
  },

  parseHTML () {
    return [
      {
        style: 'vertical-align'
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    return ['span', HTMLAttributes, 0]
  },

  addCommands () {
    return {
      verticalAlign: attrs => ({ commands }) => {
        const value = attrs && attrs.verticalAlign ? attrs.verticalAlign : null

        if (!value) {
          return commands.unsetMark(this.name)
        }

        return commands.setMark(this.name, { verticalAlign: value })
      }
    }
  }
})

export default VerticalAlign
